<script lang="ts">
	import { getContext } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { Button, ButtonV2 } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import type { SidepanelStickyBottomProps } from '../sidepanel-types';

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');
</script>

{#if $stickyBottomAction}
	{#if $stickyBottomAction.secondaryButton}
		<ButtonV2
			size="m"
			width="full"
			icon={$stickyBottomAction.secondaryButton.icon}
			disabled={$stickyBottomAction.secondaryButton.disabled}
			variant={$stickyBottomAction.secondaryButton.variant ?? 'secondary'}
			on:click={$stickyBottomAction.secondaryButton.onClick}
		>
			{$stickyBottomAction.secondaryButton.label}
		</ButtonV2>
	{/if}
	<ButtonV2
		size="m"
		width="full"
		icon={$stickyBottomAction.icon}
		class={$stickyBottomAction.secondaryButton ? `mt-${$stickyBottomAction.gap ?? 's'}` : ''}
		on:click={$stickyBottomAction.onClick}
		loading={$stickyBottomAction.loading}
		disabled={$stickyBottomAction.disabled}
	>
		{$stickyBottomAction.label ?? $format('button_save', { default: 'Save' })}
	</ButtonV2>
{/if}
